// Service areas around Round Lake Beach, IL — populates the
// AreasWeServeSection and contributes to local SEO.
export const serviceAreas = [
  { city: 'Round Lake Beach', zip: '60073' },
  { city: 'Round Lake',       zip: '60073' },
  { city: 'Round Lake Park',  zip: '60073' },
  { city: 'Round Lake Heights', zip: '60073' },
  { city: 'Grayslake',        zip: '60030' },
  { city: 'Hainesville',      zip: '60030' },
  { city: 'Lake Villa',       zip: '60046' },
  { city: 'Lindenhurst',      zip: '60046' },
  { city: 'Antioch',          zip: '60002' },
  { city: 'Fox Lake',         zip: '60020' },
  { city: 'Ingleside',        zip: '60041' },
  { city: 'Volo',             zip: '60073' },
  { city: 'Wauconda',         zip: '60084' },
  { city: 'Mundelein',        zip: '60060' },
  { city: 'Libertyville',     zip: '60048' },
  { city: 'Gurnee',           zip: '60031' },
  { city: 'Waukegan',         zip: '60085' },
  { city: 'Zion',             zip: '60099' },
];
